import { createFileRoute } from "@tanstack/react-router"
import { parseAsStringLiteral, useQueryState } from "nuqs"

import { DashboardShell } from "@/components/dashboard-shell"
import { ANALYTICS_TABS, AnalyticsTabBody } from "@/components/analytics/analytics-views"
import { InsightsError } from "@/components/analytics/insights-error"
import { InsightsFilterBar } from "@/components/analytics/insights-filter-bar"
import { InsightsProvider } from "@/components/analytics/insights-provider"
import { RouteLoading, AnalyticsLoadingSkeleton } from "@/components/route-loading"
import { ViewTabs } from "@/components/view-controls"

export const Route = createFileRoute("/analytics")({
  component: AnalyticsPage,
  head: () => ({ meta: [{ title: "Analytics" }] }),
  pendingComponent: AnalyticsPending,
  errorComponent: ({ reset }) => <InsightsError page="Analytics" retry={reset} />,
})

// One filter bar, then one tab at a time (?tab=, so a link opens the same
// tab): Overview is the quick read; Pipeline, Money, Customers and Team are
// the lenses behind it. See analytics-views.tsx for what each tab holds.

const tabParam = parseAsStringLiteral(ANALYTICS_TABS.map((t) => t.id)).withDefault("overview")

function AnalyticsPage() {
  const [tab, setTab] = useQueryState("tab", tabParam)
  return (
    <DashboardShell>
      <InsightsProvider initialFilters={{ period: "30d" }}>
        <div className="flex flex-col gap-4">
          <InsightsFilterBar page="analytics" initialPeriod="30d" title="Sales & pipeline health" />
          <ViewTabs
            tabs={ANALYTICS_TABS}
            view={tab}
            onViewChange={(v) => void setTab(v)}
            label="Analytics sections"
          />
          <AnalyticsTabBody tab={tab} />
        </div>
      </InsightsProvider>
    </DashboardShell>
  )
}

// Shown while this route's chunk downloads.
function AnalyticsPending() {
  return (
    <RouteLoading>
      <AnalyticsLoadingSkeleton />
    </RouteLoading>
  )
}
